module.exports = __webpack_public_path__ + "static/fonts/Helvetica-Regular.1aad634.woff";